export const GetNoteById = {
    endpoint: "/notes/:id",
    pathParams: ["id"],
    method: "GET",
    request: undefined,
    response: undefined,
    paginated: false
};
//# sourceMappingURL=GetNoteById.js.map